import {
    FETCH_CARS,
    FETCH_CARS_SUCCESS,
    FETCH_CARS_FAILED,
    EDIT_CAR
  } from "../store/types";
  import store from '../store/store';
  import { firebase } from '../config/configureFirebase';
  import { onValue, update, set, child, remove, push } from "firebase/database";
  import { uploadBytesResumable, getDownloadURL } from "firebase/storage";
  
// Helper: remove undefined values to prevent Firebase update errors
const removeUndefined = (obj) => {
  const cleaned = {};
  Object.keys(obj || {}).forEach((key) => {
    const val = obj[key];
    if (val !== undefined) cleaned[key] = val;
  });
  return cleaned;
};
  
export const fetchCars = () => (dispatch) => {
  // Performance optimization: Throttle car fetches
  // const now = Date.now();
  const userInfo = store.getState().auth.profile;
  // const cacheKey = userInfo?.uid || 'anonymous';
  // const lastFetch = fetchCarsCache.get(cacheKey);
  
  // if (lastFetch && (now - lastFetch) < FETCH_CARS_THROTTLE) {
  //   return; // Skip if fetched recently
  // }
  
  // fetchCarsCache.set(cacheKey, now);

  const {
      carsRef
  } = firebase;

  dispatch({
    type: FETCH_CARS,
    payload: null
  });

    onValue(carsRef(userInfo.uid, userInfo.usertype), snapshot => {
      if (snapshot.val()) {
        let data = snapshot.val();
        const arr = Object.keys(data).map(i => {
          data[i].id = i;
          // Ensure vehicleYear and vehicleColor exist
          if (!data[i].vehicleYear) data[i].vehicleYear = '';
          if (!data[i].vehicleColor) data[i].vehicleColor = '';
          return data[i]
        });

        
        dispatch({
          type: FETCH_CARS_SUCCESS,
          payload: arr
        });
      } else {
        dispatch({
          type: FETCH_CARS_FAILED,
          payload: store.getState().languagedata.defaultLanguage.no_cars
        });
      }
    });
  };
  
  export const editCar = (car, method) => async (dispatch) => {
    // Check if firebase is initialized
    if (!firebase) {
      throw new Error('Firebase not initialized');
    }
    
    // Check if required references exist
    if (!firebase.carAddRef) {
      throw new Error('Firebase carAddRef not available');
    }
    
    const {
      singleUserRef,
      carAddRef, 
      carEditRef,
      carImage
    } = firebase;
    dispatch({
      type: EDIT_CAR,
      payload: { method, car }
    });
    if (method === 'Add') {
        push(carAddRef, car);
    } else if (method === 'Delete') {
        remove(carEditRef(car.id));
    } else if (method === 'UpdateImage') {
      await uploadBytesResumable(carImage(car.id),car.car_image);
      let image = await getDownloadURL(carImage(car.id));
      let data = car;
      data.car_image = image;
      set(carEditRef(car.id), data);
      if(car.active && car.driver){
        update(singleUserRef(car.driver), {
          updateAt: new Date().getTime(),
          car_image: image
        });
      }   
    }
     else {
        set(carEditRef(car.id),car);
        // Update user profile if car is active
        if(car.active && car.driver){
          const userData = removeUndefined({
            carType: car.carType,
            category: car.category,
            vehicleNumber: car.vehicleNumber,
            vehicleMake: car.vehicleMake,
            vehicleModel: car.vehicleModel,
            vehicleYear: car.vehicleYear,
            vehicleColor: car.vehicleColor,
            other_info: car.other_info,
            car_image: car.car_image,
            carApproved: car.approved,
            updateAt: new Date().getTime()
          });
          console.log('🔄 Updating user profile with vehicle data:', {
            driverId: car.driver,
            vehicleYear: car.vehicleYear,
            vehicleColor: car.vehicleColor,
            carType: car.carType
          });
          
          // Force update user profile with car data (undefined filtered)
          update(singleUserRef(car.driver), userData).then(() => {
            console.log('✅ User profile updated successfully');
          }).catch(error => {
            console.error('❌ Failed to update user profile:', error);
          });
        }
    }
  }

  export const updateUserCarWithImage = (newData, blob = null) => async (dispatch) => {
    // Check if firebase is initialized
    if (!firebase) {
      throw new Error('Firebase not initialized');
    }
    
    // Check if required references exist
    if (!firebase.carAddRef) {
      throw new Error('Firebase carAddRef not available');
    }
    
    const {
      auth,
      carAddRef,
      singleUserRef,
      carImage
    } = firebase;

    try {
      console.log('🚗 Starting car image upload...');
      
      var carId = push(carAddRef).key;
      console.log('🚗 Generated car ID:', carId);

      if (blob) {
        // FIXED: Better error handling for upload
        const uploadTask = uploadBytesResumable(carImage(carId), blob);
        
        // FIXED: Add upload progress monitoring
        uploadTask.on('state_changed', 
          (snapshot) => {
            const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
            console.log('📤 Upload progress:', progress + '%');
          },
          (error) => {
            console.error('❌ Upload error:', error);
            throw error;
          }
        );

        // FIXED: Wait for upload to complete
        await uploadTask;
        console.log('✅ Upload completed successfully');
        
        // FIXED: Close blob after upload
        if (blob && typeof blob.close === 'function') {
          blob.close();
        }
        
        // FIXED: Get download URL
        const url = await getDownloadURL(carImage(carId));
        console.log('🔗 Download URL obtained:', url);
        
        // FIXED: Update data with image URL
        newData.car_image = url;
        await set(child(carAddRef, carId), newData);
        console.log('💾 Car data saved to database');
      } else {
        await set(child(carAddRef, carId), newData);
        console.log('💾 Car data saved to database');
      }
      
      // FIXED: Update user profile if car is active
      if (newData.active) {
        let updateData = {
          carType: newData.carType,
          category: newData.category,
          vehicleNumber: newData.vehicleNumber,
          vehicleMake: newData.vehicleMake,
          vehicleModel: newData.vehicleModel,
          vehicleYear: newData.vehicleYear,
          vehicleColor: newData.vehicleColor,
          other_info: newData.other_info,
          car_image: blob ? url : newData.car_image,
          carApproved: newData.approved,
          updateAt: new Date().getTime()
        };
        const cleanedUpdateData = removeUndefined(updateData);
        console.log('📝 Data yang akan diupdate ke user profile:', cleanedUpdateData);
        await update(singleUserRef(auth.currentUser.uid), cleanedUpdateData);
        console.log('👤 User profile updated with car image');
      }
      
      console.log('✅ Car image upload completed successfully');
      
    } catch (error) {
      console.error('❌ Car image upload failed:', error);
      
      // FIXED: Close blob on error
      if (blob && typeof blob.close === 'function') {
        blob.close();
      }
      
      // FIXED: Re-throw error for UI handling
      throw error;
    }
  };